import React, { useMemo, useRef, useState, useEffect } from 'react';


import ProductCard from '../components/ProductCard';
import { supabase } from '../supabaseClient';

const ProductDetailPage = ({ productId, onAddToCart, onProductClick }) => {
  const [product, setProduct] = useState(null);
  const [mainImage, setMainImage] = useState('');
  const [quantity, setQuantity] = useState(1);
  const [relatedProducts, setRelatedProducts] = useState([]);

  useEffect(() => {
    const fetchProduct = async () => {
      const { data, error } = await supabase
        .from('products')
        .select('*')
        .eq('id', productId)
        .single();

      if (error || !data) {
        console.error('Producto no encontrado:', error);
        setProduct(null);
      } else {
        setProduct(data);
        setMainImage(data.image);
        setQuantity(1);
        fetchRelatedProducts(data.category, data.id);
      }
    };

    const fetchRelatedProducts = async (category, currentId) => {
      const { data, error } = await supabase
        .from('products')
        .select('*')
        .eq('category', category)
        .neq('id', currentId)
        .limit(4);

      if (!error) setRelatedProducts(data);
    };

    fetchProduct();
  }, [productId]);

  const handleQuantityChange = (e) => {
    const value = parseInt(e.target.value);
    if (value > 0) setQuantity(value);
  };

  const handleIncrement = () => setQuantity((prev) => prev + 1);
  const handleDecrement = () => setQuantity((prev) => (prev > 1 ? prev - 1 : 1));

  const handleAddToCartClick = () => {
    if (product) {
      onAddToCart({ ...product, quantity });
    }
  };

  if (!product) {
    return (
      <div className="container mx-auto px-4 sm:px-6 py-8 sm:py-12 text-center text-gray-600">
        Producto no encontrado.
      </div>
    );
  }

  return (
    <div className="container mx-auto px-4 sm:px-6 py-8 sm:py-12">
      <div className="bg-white rounded-2xl p-6 sm:p-8 flex flex-col lg:flex-row gap-8">
        {/* Galería de imágenes */}
        <div className="w-full lg:w-1/2 flex flex-col items-center">
          <img
            src={mainImage}
            alt={product.name}
            className="w-full max-h-96 object-contain rounded-xl mb-4"
          />
          {Array.isArray(product.images) && product.images.length > 0 && (
            <div className="flex space-x-2 overflow-x-auto pb-2">
              {product.images.map((img, index) => (
                <img
                  key={index}
                  src={img}
               
                  alt={`${product.name} thumbnail ${index + 1}`}
                  className={`w-20 h-20 object-cover rounded-lg cursor-pointer border-2 ${
                    mainImage === img ? 'border-[#5A61E5]' : 'border-transparent'
                  } hover:border-[#5A61E5] transition-all duration-200`}
                  onClick={() => setMainImage(img)}
                />
              ))}
            </div>
          )}
        </div>

        {/* Detalles del producto */}
        <div className="w-full lg:w-1/2 flex flex-col justify-between">
          <div>
            <h1 className="text-4xl font-extrabold text-gray-900 mb-3">{product.name}</h1>
            <span className="inline-block bg-[#5A61E5] text-white text-xs font-semibold px-2.5 py-0.5 rounded-full mb-4">
              SKU: {product.sku || ''}
            </span>
            <p className="text-gray-800 text-3xl font-bold mb-6">
              ₡{product.price.toLocaleString('es-CR', { minimumFractionDigits: 2 })}
            </p>
         <div
  className="prose prose-sm list-inside"
  dangerouslySetInnerHTML={{ __html: product.description }}
/>

<br />
            <div className="flex items-center mb-6">
              <label htmlFor="quantity-selector" className="text-gray-700 font-medium mr-4">Cantidad:</label>
              <div className="flex items-center border border-gray-300 rounded-lg overflow-hidden">
                <button onClick={handleDecrement} className="px-4 py-2 bg-gray-100 text-gray-600 hover:bg-gray-200">-</button>
                <input
                  type="number"
                  id="quantity-selector"
                  value={quantity}
                  onChange={handleQuantityChange}
                  className="w-16 text-center border-l border-r border-gray-300 focus:outline-none"
                  min="1"
                />
                <button onClick={handleIncrement} className="px-4 py-2 bg-gray-100 text-gray-600 hover:bg-gray-200">+</button>
              </div>
            </div>
          </div>
          <button
            onClick={handleAddToCartClick}
            className="w-full bg-[#5A61E5] text-white py-3 rounded-xl hover:bg-[#4A51D5] transition-colors duration-300 shadow-lg text-lg font-semibold"
          >
            Agregar al Carrito
          </button>
        </div>
      </div>

      {/* Productos relacionados */}
      {relatedProducts.length > 0 && (
        <div className="mt-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-6 text-center">Productos Relacionados</h2>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 sm:gap-6">
            {relatedProducts.map((p) => (
              <ProductCard key={p.id} product={p} onAddToCart={onAddToCart} onProductClick={onProductClick} />
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default ProductDetailPage;
